import BaseApiAction from '@Actions/base-api-action';

export default class LinkUserToTeam extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-linkUserToTeam',
      payload: {
        user_id: this._payload.user_id,
        team_id: this._payload.team_id,
      },
    });
  }
  onSuccess(data) {
    super.onSuccess(...arguments);
  }
}
